/* global window, document, location, console */
import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import Modal from "./Modal";
import Heroicon from "./Heroicon";

function DeleteInvite({ id, email, revoke }) {
  let [isOpen, setIsOpen] = useState(false);
  let [isThereSuccess, setIsThereSuccess] = useState(false);

  const title = revoke ? "Revoke" : "Delete";

  function closeModal(value) {
    setIsOpen(value);
  }

  function openModal(value) {
    setIsOpen(value);
  }

  function deleteInvite(e) {
    e.preventDefault();

    window.axios
      .delete("/api/v2/team-members/" + id)
      .then(function (response) {
        if (response.status === 200) {
          setIsThereSuccess(true);
        }
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  return (
    <>
      <button
        className={`${
          revoke ? "btn-outlined" : "btn-solid"
        } text-xs sm:text-sm btn-red`}
        onClick={() => openModal(id)}
      >
        {title}
      </button>

      {!isThereSuccess ? (
        <Modal
          title={revoke ? "Revoke Team Member" : "Delete Team Member"}
          isOpen={isOpen === id}
          closeModal={closeModal}
        >
          <p className="p-4 m-4 text-sm rounded-md sm:text-base alert alert--danger">
            <Heroicon
              icon="o-exclamation-circle"
              style="mr-3 w-6 h-6 sm:w-10 sm:h-10 text-red-600"
            />
            {revoke
              ? "This will revoke access for " + email + "."
              : "This will permanently delete " +
                email +
                ". This action cannot be undone."}
          </p>
          <div className="flex flex-wrap justify-between gap-2 px-6 py-4 mt-6 bg-gray-200">
            <button
              className="btn-solid btn-red"
              id="delete-user"
              onClick={(e) => deleteInvite(e)}
            >
              {title} Team Member
            </button>

            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                closeModal();
              }}
              className="inline-block btn-solid btn-dark"
            >
              Close
            </a>
          </div>
        </Modal>
      ) : (
        <Modal
          title="Delete team member"
          isOpen={true}
          closeModal={() => location.reload()}
        >
          <div className="flex-col p-4 m-4 text-sm rounded-md sm:text-base alert alert--success">
            <Heroicon
              icon="o-check-circle"
              style="mr-3 w-12 h-12 sm:w-16 sm:h-16 text-green-600"
            />
            <p className="mt-4">Team member deleted successfully!</p>
            <p>{email}</p>
          </div>
          <div className="flex justify-end px-6 py-4 mt-6 bg-gray-200">
            <button
              className="btn-solid btn-dark"
              onClick={() => location.reload()}
            >
              Close
            </button>
          </div>
        </Modal>
      )}
    </>
  );
}

const initDeleteInvite = function (selector) {
  const elements = document.querySelectorAll(selector);
  if (elements.length > 0) {
    elements.forEach((element) => {
      const root = createRoot(element);
      const id = JSON.parse(element.dataset.id);
      const email = JSON.parse(element.dataset.email);
      const revoke = element.dataset.revoke === "true";
      root.render(<DeleteInvite id={id} email={email} revoke={revoke} />);
    });
  }
};
export { DeleteInvite as default, initDeleteInvite };
